import { tsLoginConfig, tsWhoAmI } from '../../Typescript/API_Response'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { AxiosResponse } from 'axios'
import UserService from '../PHP/APIs/UserService'
import { useUserContext } from '../../Contexts/UserConfig'
import { LocalAutoLoginAuth } from '../../Functions/LocalAutoLoginAuth'

export function useGetLoginConfig(auth: tsWhoAmI | undefined) {
  const { setError } = useMessagePopupContext()
  return useQuery<tsLoginConfig | any, AxiosResponse>(
    ['UserService', 'getAtLoginConfig', auth?.user],
    () => UserService.getAtLoginConfig(auth!),
    {
      enabled: !!auth?.token,
      onError: (err) => setError(err),
    },
  )
}

export function useSetUserPref() {
  const queryClient = useQueryClient()
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useMutation<
    any,
    AxiosResponse,
    { name: string; value: any },
    () => void
  >(
    ['UserService', 'getAtLoginConfig'],
    ({ name, value }) => UserService.setUserPref(whoAmI!, name, value),
    {
      onError: (err) => setError(err),
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['UserService', 'getAtLoginConfig'],
        })
      },
    },
  )
}

export function useGetWhoAmI() {
  const { setWhoAmI } = useUserContext()
  const { setMessage } = useMessagePopupContext()
  return useQuery<tsWhoAmI, AxiosResponse>(
    ['UserService', 'getWhoAmI'],
    () => UserService.getWhoAmI(),
    {
      onSuccess: (data) => {
        if (data?.token) {
          setWhoAmI(data)
        } else {
          if (process.env.REACT_APP_STAGE !== 'local') {
            //if local, then cached LocalAutoLoginAuth() has been used and invalid data can be ignored
            setMessage({
              subject: 'Incomplete Auth Response',
              message: 'Missing token',
              severity: 'warning',
            })
          }
        }
      },
      onError: (err) => {
        // no need to "setError" as response is handled in RequiredAuth
        console.error(err)
      },
      initialData: () => LocalAutoLoginAuth(),
    },
  )
}
